<template>
  <AtomsCalculatorFrame
    iframe-class="!mx-auto"
    :type="type"
    :src="src"
  />
</template>

<script>
export default {
  name: 'MoleculesCalculatorRefinance',

  data: () => ({
    type: 'Mortgage_Switching_Calculator',
    src: '//www.visionabacus.net/Tools/B3/SuiteA/G300/Mortgage_Switching_Calculator/CompareClub'
  })
}
</script>
